var modal = document.getElementById("myModals");


// Get the <span> element that closes the modal
var span = document.getElementsByClassName("cartpopup_close")[0];

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
   $('.card_popup').show();
}

function showLoader(){
 $("#MainContent").append('<div class="wait"></div>');
}


 $(document).on('click','.change_card',function(e){
   $('.card_addcart_popup').hide(); 
   $('.card_popup').show();
 });